module.exports = __webpack_public_path__ + "img/avatar9.c25686ac.jpg";